import { CrudModel } from '@core/crud/crud-model.interface';


export interface Parametry extends CrudModel {
    uid: string;
    phone: string;
    email: string;
    host: string;
    password: string;
    port: number;
    typeConfig: number;
    percentageUala: number;
    pointsClient: number;
    pointsProvider: number;
    pricePremium: number;
    pricePreferid: number;
    tax: number;
    totalTasks: number;
    architect: { name: string; phoneArea: string; phoneNumber: string; countryCode: string };
    CSVTemplateConsorcistas: string;
    messageCost: number;
    totalConsorcios: number;
    /* con esta cantidad de mensajes disponibles o menos se avisa "quedan pocos mensajes" (topbar) */
    lowMessagesWarning: number;
    /* cada cuántos minutos, como mínimo, se consulta el estado real de la conexión de WhatsApp (AF327). Si falta, 15 */
    wspStatusCheckMinutes?: number;
}

export const MODEL = 'parametry';
export const MODELSUPPORT = 'support';
export const MODELSMTP = 'smtp';
export const MODELGLOBAL = 'global';
